import { Routes } from '@angular/router';
import { VerifyUserComponent } from './features/verify-user/verify-user.component';
import { ResetPasswordComponent } from './features/reset-password/reset-password/reset-password.component';
import { PrivacyPolicyComponent } from './features/privacy-policy/privacy-policy.component';
import { UserListComponent } from './features/userlist/components/userlist/userlist.component';
import { LoginComponent } from './features/login/login.component';
import { NotificacionesComponent } from './features/notificaciones/components/notificaciones/notificaciones.component';
import { NotificacionNuevaComponent } from './features/notificaciones/components/notificacion-nueva/notificacion-nueva.component';
import { MainLayoutComponent } from './core/components/main-layout/main-layout.component';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'verify-user',
    component: VerifyUserComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: 'userlist', component: UserListComponent },
      { path: 'notificaciones', component: NotificacionesComponent },
      { path: 'notificaciones/nueva', component: NotificacionNuevaComponent },
      { path: 'notificaciones/:id/editar', component: NotificacionNuevaComponent },
      // Lazy: el código de esta pantalla queda fuera del bundle inicial y se
      // descarga recién al entrar a la ruta.
      {
        path: 'auditoria/:id',
        loadComponent: () => import('./features/notificaciones/components/notificacion-auditoria/notificacion-auditoria.component')
          .then(m => m.NotificacionAuditoriaComponent)
      }
    ]
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent
  },
  {
    path: 'politicas-privacidad',
    component: PrivacyPolicyComponent
  },
  {
    path: '',
    redirectTo: 'verify-user',
    pathMatch: 'full'
  }
];